// extracted by mini-css-extract-plugin
module.exports = {"container":"az_NYb","imageContainer":"az_OYb","image":"az_PYb","heading":"az_QYb","description":"az_RYb"};